import { create } from "zustand";
import axios from "axios";

const useStatusStore = create((set) => ({
    deliveryAvailable: false,
    orderAvailable: false,
    isInDeliveryTime: false,
    isInPickupTime: false,
    closure: null,
    loading: false,
    error: null,

    fetchDeliveryAvailable: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/deliveryAvailable");
            set({ deliveryAvailable: response.data.deliveryAvailable, loading: false });
        } catch (error) {
            set({ error: "Error fetching delivery availability", loading: false });
        }
    },

    fetchOrderAvailable: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/orderAvailable");
            set({ orderAvailable: response.data.orderAvailable, loading: false });
        } catch (error) {
            set({ error: "Error fetching order availability", loading: false });
        }
    },

    fetchIsInDeliveryTime: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/inDeliveryTime");
            set({ isInDeliveryTime: response.data.inDeliveryTime, loading: false });
        } catch (error) {
            set({ error: "Error checking delivery time", loading: false });
        }
    },

    // Kommende oder laufende Betriebsschließung (z. B. Umzug), sonst null.
    fetchClosure: async () => {
        try {
            const response = await axios.get("/api/public/status/closure");
            set({ closure: response.data.closure });
        } catch (error) {
            set({ closure: null });
        }
    },

    // Sonderöffnung { active, note } oder null.
    specialOpening: null,
    fetchSpecialOpening: async () => {
        try {
            const response = await axios.get("/api/public/status/specialOpening");
            set({ specialOpening: response.data });
        } catch (error) {
            set({ specialOpening: null });
        }
    },

    fetchInPickupTime: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/inPickupTime");
            set({ isInPickupTime: response.data.inPickupTime, loading: false });
        } catch (error) {
            set({ error: "Error checking pickup time", loading: false });
        }
    },
}));

export default useStatusStore;
